var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiList1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15625 24.75C5.15625 24.4765 5.2649 24.2142 5.4583 24.0208C5.65169 23.8274 5.914 23.7188 6.1875 23.7188H26.8125C27.086 23.7188 27.3483 23.8274 27.5417 24.0208C27.7351 24.2142 27.8438 24.4765 27.8438 24.75C27.8438 25.0235 27.7351 25.2858 27.5417 25.4792C27.3483 25.6726 27.086 25.7812 26.8125 25.7812H6.1875C5.914 25.7812 5.65169 25.6726 5.4583 25.4792C5.2649 25.2858 5.15625 25.0235 5.15625 24.75ZM5.15625 16.5C5.15625 16.2265 5.2649 15.9642 5.4583 15.7708C5.65169 15.5774 5.914 15.4688 6.1875 15.4688H26.8125C27.086 15.4688 27.3483 15.5774 27.5417 15.7708C27.7351 15.9642 27.8438 16.2265 27.8438 16.5C27.8438 16.7735 27.7351 17.0358 27.5417 17.2292C27.3483 17.4226 27.086 17.5312 26.8125 17.5312H6.1875C5.914 17.5312 5.65169 17.4226 5.4583 17.2292C5.2649 17.0358 5.15625 16.7735 5.15625 16.5ZM5.15625 8.25C5.15625 7.9765 5.2649 7.71419 5.4583 7.5208C5.65169 7.3274 5.914 7.21875 6.1875 7.21875H26.8125C27.086 7.21875 27.3483 7.3274 27.5417 7.5208C27.7351 7.71419 27.8438 7.9765 27.8438 8.25C27.8438 8.5235 27.7351 8.78581 27.5417 8.9792C27.3483 9.1726 27.086 9.28125 26.8125 9.28125H6.1875C5.914 9.28125 5.65169 9.1726 5.4583 8.9792C5.2649 8.78581 5.15625 8.5235 5.15625 8.25Z",
    fill: "#1D2951"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiList1);
export default __webpack_public_path__ + "static/media/bi_list (1).1f3ba05cf70e1b0ebe3079117603e3b8.svg";
export { ForwardRef as ReactComponent };